import _ from 'lodash'
import CompareMixin from '../components/filters/compare-mixin'

// Label for a workflow filter's selected workflow. A partner ref the firm
// could not resolve (template not imported) is not the default workflow —
// say so instead of pretending it is. Filters whose editor stores a sentinel
// for "default workflow" (preparation & review's DEFAULT_WORKFLOW_ID) pass it
// as defaultWorkflowId so it is not mistaken for a real firm workflow id.
export function workflowFilterLabel(settings, getters, defaultWorkflowId) {
  if (
    settings.firmWorkflowId &&
    settings.firmWorkflowId !== defaultWorkflowId
  ) {
    return getters.getFilterDropdownValueLabel(
      'firm_workflow',
      settings.firmWorkflowId
    )
  }

  if (settings.partnerWorkflowId) {
    return (
      settings.partnerWorkflowName ||
      I18n.t('firm_workflows.not_available_label')
    )
  }

  return I18n.t('firm_workflows.default_label')
}

// Label for a reconciliation-scoped filter's selected reconciliation. A partner
// ref the firm could not resolve is shown as unavailable rather than blank.
export function reconciliationLabelFor(settings, getters) {
  if (settings.reconciliationTextId) {
    return getters.getReconciliationTextById(settings.reconciliationTextId)
      ?.name
  }

  if (settings.partnerReconciliationTextId) {
    return (
      settings.partnerReconciliationTextName ||
      I18n.t('companies_overview.filters.reconciliation_not_available')
    )
  }

  return undefined
}

export function getComparisonLabel(comparisonMode, comparisonModes) {
  const mode = _.find(comparisonModes, { value: comparisonMode })
  return (mode && mode.label) || ''
}

export function titleize(string, condition = true) {
  return condition ? _.startCase(string) : string
}

export function normalizeSettingsForShowAll(
  settings,
  clearField,
  clearValue = ''
) {
  if (settings.comparisonMode === CompareMixin.TYPES.SHOW_ALL) {
    return {
      ...settings,
      [clearField]: clearValue,
    }
  }

  return settings
}
